import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
interface MobileNavProps {
  isOpen: boolean;
  onClose: () => void;
  links: Array<{
    name: string;
    path: string;
  }>;
}
export function MobileNav({
  isOpen,
  onClose,
  links
}: MobileNavProps) {
  const location = useLocation();
  // Close nav when route changes
  useEffect(() => {
    onClose();
  }, [location.pathname, onClose]);
  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);
  return <>
      {/* Backdrop */}
      <div className={`fixed inset-0 bg-charcoal-900/20 backdrop-blur-sm z-40 transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} onClick={onClose} data-id="element-109" />

      {/* Drawer */}
      <div className={`fixed top-0 right-0 h-full w-[300px] bg-cream-100 shadow-2xl z-50 transform transition-transform duration-300 ease-in-out ${isOpen ? 'translate-x-0' : 'translate-x-full'}`} data-id="element-110">
        <div className="p-6 flex justify-end" data-id="element-111">
          <button onClick={onClose} className="p-2 text-charcoal-900 hover:text-sage-500 transition-colors" aria-label="Close menu" data-id="element-112">
            <X size={24} data-id="element-113" />
          </button>
        </div>

        <nav className="px-8 py-4" data-id="element-114">
          <ul className="space-y-6" data-id="element-115">
            {links.map(link => <li key={link.path} data-id="element-116">
                <Link to={link.path} className={`block text-2xl font-serif ${location.pathname === link.path ? 'text-sage-500 italic' : 'text-charcoal-900 hover:text-sage-500'} transition-colors`} data-id="element-117">
                  {link.name}
                </Link>
              </li>)}
          </ul>
        </nav>

        <div className="absolute bottom-8 left-0 w-full px-8 text-center" data-id="element-118">
          <p className="text-sm text-charcoal-900/60 font-sans" data-id="element-119">
            Down Home Interiors
            <br data-id="element-120" />
            Howell, MI
          </p>
        </div>
      </div>
    </>;
}